import { render, staticRenderFns } from "./GeneralSpecialtyDelete.vue?vue&type=template&id=5960c8ed&scoped=true&"
import script from "./GeneralSpecialtyDelete.vue?vue&type=script&lang=js&"
export * from "./GeneralSpecialtyDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5960c8ed",
  null
  
)

export default component.exports